// @flow
import SystemView from "./SystemView";

export default SystemView;
